module.exports = __webpack_public_path__ + "img/oats.3ebd4b24.svg";